import React, { useEffect, useState, useRef } from 'react'
import Navbar from '../Navbar';
import { useNavigate, useParams } from 'react-router-dom';
import { MdEditSquare } from "react-icons/md";
import axios from 'axios';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import Menu_Items from '../Menu_Items';
import { FaAngleDown } from "react-icons/fa";
import { DayPicker } from "react-day-picker";

function Edit_In_Bound() {
    const { id, int_id, E_id } = useParams();
    const [su_admin, setsu_admin] = useState(false)
    const [admin, setadmin] = useState(false)
    const [In_bound, setIn_bound] = useState({ com_id: id, integ_id: int_id, server: '', type: '' });
    const [file, setFile] = useState(null);
    const [private_key, setprivate_key] = useState(null);
    const [randomNumber, setRandomNumber] = useState('');
    const [selectedDays, setSelectedDays] = useState([]);
    const [selectedDate, setSelectedDate] = useState([]);
    const [formattedDates, setFormattedDates] = useState([]);
    const [selectedTime, setselectedTime] = useState([]);
    const [open, setOpen] = useState(false);
    const [showtime, setshowtime] = useState(false);
    const dropdownRef = useRef(null);
    const TimedownRef = useRef(null);
    const ref = useRef();

    const navigate = useNavigate();
    const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const hoursArray = [
        "00:00", "01:00", "02:00", "03:00", "04:00", "05:00",
        "06:00", "07:00", "08:00", "09:00", "10:00", "11:00",
        "12:00", "13:00", "14:00", "15:00", "16:00", "17:00",
        "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"
    ];
    const countryTimeZones = {
        "India": "+05:30",
        "United States (Eastern Time)": "-05:00",
        "United States (Central Time)": "-06:00",
        "United States (Mountain Time)": "-07:00",
        "United States (Pacific Time)": "-08:00",
        "United Kingdom": "+00:00",
        "Australia (Sydney)": "+10:00",
        "Australia (Perth)": "+08:00",
        "Canada (Toronto)": "-05:00",
        "Canada (Vancouver)": "-08:00",
        "Germany": "+01:00",
        "France": "+01:00",
        "Italy": "+01:00",
        "Spain": "+01:00",
        "Russia (Moscow)": "+03:00",
        "China": "+08:00",
        "Japan": "+09:00",
        "South Korea": "+09:00",
        "Singapore": "+08:00",
        "United Arab Emirates": "+04:00",
        "Saudi Arabia": "+03:00",
        "Brazil (São Paulo)": "-03:00",
        "Argentina": "-03:00",
        "South Africa": "+02:00",
        "Nigeria": "+01:00",
        "Mexico": "-06:00",
        "New Zealand": "+12:00",
        "Pakistan": "+05:00",
        "Bangladesh": "+06:00",
        "Thailand": "+07:00",
        "Indonesia (Jakarta)": "+07:00",
        "Philippines": "+08:00",
        "Vietnam": "+07:00",
        "Turkey": "+03:00",
        "Egypt": "+02:00",
        "Israel": "+02:00"
    };
    const menus = [
        {
            name: 'Integrations',
            id
        },
        {
            name: 'In Bound',
            id,
            submenu: [
                { name: 'Schedule', id, int_id, type: 'In' },
                { name: 'API', id, int_id },
                { name: 'Manual', id, int_id }
            ]
        },
        (su_admin || admin ? { name: 'Users', id } : { name: null, id })
    ];
    const get_details = async () => {
        await axios.get(`/in_bound/Edit/${E_id}`).then((res) => {
            const server = JSON.parse(res.data.server);
            const store_db = JSON.parse(res.data.store_db);
            let value = res.data;
            const { date, time } = value
            value.server = server;
            value.store_db = store_db;
            value.date = JSON.parse(date);
            value.time = JSON.parse(time);
            setRandomNumber(value.sample);
            if (value.date?.type === "Weekly") {
                setSelectedDays(value.date?.value || [])
            } else if (value.date?.type === "Monthly") {
                const dates = value.date?.value || []
                setFormattedDates(dates);
                const strdate = dates.map(dateStr => {
                    // Split dd/mm/yyyy → [dd, mm, yyyy]
                    const [day, month, year] = dateStr.split('/');
                    // Create Date object (month - 1 because JS months are 0-based)
                    return new Date(year, month - 1, day);
                });
                // console.log();
                setSelectedDate(strdate);
            }
            if (value.time?.hours) {
                setselectedTime(value.time?.hours)
            }
            // console.log(value.date);
            setIn_bound(value);
        })
            .catch((err) => {
                toast.error(`Edit Details Couldn't be Fetched`, {
                    autoClose: 1000
                });
            })
    };
    const handle_details = (key, value, additional = null) => {
        if (key === 'date') {
            setIn_bound({
                ...In_bound, [key]: {
                    type: value,
                    value: []
                }
            });
        } else if (key === 'time') {
            setIn_bound({
                ...In_bound, [key]: {
                    country: value,
                    value: countryTimeZones[value]
                }
            });
        } else {
            if (additional === null) {
                setIn_bound({
                    ...In_bound, [key]: value
                });
            }
            else {
                setIn_bound((prevState) => ({
                    ...prevState,
                    [additional]: {
                        ...prevState[additional], // Keep existing keys in additional
                        [key]: value              // Update or add the specified key-value pair
                    }
                }));

            }
        }

    };
    const handle_from_store = async (key, value) => {
        try {
            if (value === 'Internal') {
                setIn_bound((prevState) => ({
                    ...prevState, [key]: value,
                    server: ''
                }));
            }
            else if (value === 'External') {
                setIn_bound((prevState) => ({
                    ...prevState, [key]: value,
                    server: ''
                }));
            }
            else if (value === 'same') {
                setIn_bound((prevState) => ({
                    ...prevState, [key]: value,
                    store_db: ''
                }))
            }
            else {
                setIn_bound((prevState) => ({
                    ...prevState, [key]: value,
                    store_db: ''
                }))
            }
        }
        catch (error) {
            console.error('Error in handle_from_store:', error);
        }

    };
    const hanlde_sample_file = (e) => {
        setFile(e.target.files[0]);
    };
    const hanlde_private_key = (e) => {
        setprivate_key(e.target.files[0]);
    };
    const handle_folder_path = (value) => {
        const convertedPath = value.replace(/\\/g, '/');
        return convertedPath;
    };
    const upload_key = async (sequence_no) => {
        let formData = new FormData();
        formData.append("key", private_key);
        formData.append("filename", `${sequence_no}`);
        await axios.post(`/in_bound/upload_key`, formData).then((res) => {

        })
            .catch((err) => {
                console.log(`error`);
            });
    };
    const upload_sample_file = async (sequence_no) => {
        let formData = new FormData();
        formData.append("sample_file", file);
        formData.append("filename", `${sequence_no}`);
        await axios.post(`/in_bound/sample_file`, formData).then((res) => {
        })
            .catch((err) => {
                console.log(`error`);
            });
    };
    const update_In_bound = async () => {
        const { date, time } = In_bound;
        const datevalue = {
            ...date, value: date.type === 'Weekly' ? selectedDays : formattedDates
        };
        const timevalue = {
            ...time, hours: selectedTime
        }
        const data = {
            ...In_bound, date: datevalue, time: timevalue
        }
        await axios.patch(`/in_bound/update/${In_bound.id}`, data).then((res) => {
            navigate(`/in_bound_details/${id}/${int_id}`);
        })
            .catch((err) => {
                console.log('err');
            })
    };
    const toggleDropdown = () => {
        setOpen(!open);
    };
    const toggleDay = (day) => {
        setSelectedDays(prev =>
            prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
        );
    };
    const handledate = (dates) => {
        setSelectedDate(dates || []);
        // format to dd/mm/yyyy
        const formatted = (dates || []).map((date) => {
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-indexed
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        });
        setFormattedDates(formatted)
    };
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setOpen(false);
        }
        if (TimedownRef.current && !TimedownRef.current.contains(event.target)) {
            setshowtime(false);
        }
        if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
        }
    };
    const toggleDropdowntime = () => {
        setshowtime(!showtime)
    };
    const toggletime = (time) => {
        setselectedTime(prev =>
            prev.includes(time) ? prev.filter(d => d !== time) : [...prev, time]
        );
    };
    const countryList = () => {
        return Object.keys(countryTimeZones)
    }
    const Toady_Date = () => {
        const now = new Date();
        return `${now.getDate().toString().padStart(2, '0')} - ${(now.getMonth() + 1).toString().padStart(2, '0')} - ${now.getFullYear()}`;
    };
    const submit = () => {
        if (private_key && In_bound.server.type === 'key') {
            upload_key(randomNumber)
        }
        if (file) {
            upload_sample_file(randomNumber)
        }
        update_In_bound()
        // console.log(formattedDates);
        // console.log(selectedDate);

    }
    const get_level = () => {
        const level = Cookies.get("level");
        if (level === "Super Admin") {
            setsu_admin(true);
        }
        else if (level === 'Admin') {
            setadmin(true)
        }

    };
    useEffect(() => {
        get_details()
        get_level();
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    return (
        <div className='container df fdc jb ac'>
            <Navbar />
            <div className='main_box df'>
                <Menu_Items menu={menus} />
                <div className='content df fdc ac'>
                    <div className='page_header df jb ac'>
                        <div className='w90 df ac'>
                            <MdEditSquare className='page_icon db' />
                            <p>Edit In Bound</p></div>
                    </div>
                    <div className='box df fdc'>
                        <div className='create_box'>
                            <div>
                                <label htmlFor='import_name'>Import Name</label>
                                <input type='search' id='import_name' value={In_bound.import_name || ""} onChange={(e) => handle_details('import_name', e.target.value)} />
                            </div>
                            <div>
                                <label>Files From</label>
                                <select onChange={(e) => { handle_from_store('from', e.target.value) }} value={In_bound.from || ""} disabled>
                                    <option>Please Select</option>
                                    <option value={`External`}>External</option>
                                </select>
                            </div>
                            <div id={In_bound.from === 'External' ? 'block' : 'none'}>
                                <label>Enter Host ID</label>
                                <input type='search' id='Host' value={In_bound.server?.host || ""} onChange={(e) => handle_details('host', e.target.value, 'server')} />
                            </div>
                            <div id={In_bound.from === 'External' ? 'block' : 'none'}>
                                <label>Enter User Name</label>
                                <input type='search' id='User' value={In_bound.server?.user || ""} onChange={(e) => handle_details('user', e.target.value, 'server')} />
                            </div>
                            <div id={In_bound.from === 'External' ? 'block' : 'none'}>
                                <label>Select Security Type</label>
                                <select onChange={(e) => { handle_details('type', e.target.value, 'server') }} value={In_bound.server?.type || ""}>
                                    <option>Please Select</option>
                                    <option value={'password'}>Password</option>
                                    <option value={'key'}>Private Key</option>
                                </select>
                            </div>
                            <div id={In_bound.server.type === 'password' ? 'block' : 'none'}>
                                <label>Enter Password</label>
                                <input id="s_pass" type="search" value={In_bound.server?.pass || ""} onChange={(e) => handle_details('pass', e.target.value, 'server')} />
                            </div>
                            <div id={In_bound.server.type === 'key' ? 'block' : 'none'}>
                                <label>Select Private key</label>
                                <input id="fileSelect" type="file" required accept='.pem' onChange={(e) => { handle_details('pass', `${randomNumber}`, 'server'); hanlde_private_key(e) }} />
                            </div>
                            <div>
                                <label>Enter Files Path</label>
                                <input type='search' id='path' value={In_bound.path || ''} onChange={(e) => handle_details('path', handle_folder_path(e.target.value))} />
                            </div>
                            <div>
                                <label>Files Type</label>
                                <select onChange={(e) => handle_details('type', e.target.value)} value={In_bound.type || ''}>
                                    <option>Please Select</option>
                                    <option value={'.csv'}>.CSV</option>
                                    <option value={'.json'}>.JSON</option>
                                    <option value={'.xml'}>.XML</option>
                                </select>
                            </div>
                            <div>
                                <label>File Name Starting With</label>
                                <input type='search' id='start_with' value={In_bound.start_with || ''} onChange={(e) => handle_details('start_with', e.target.value)} />
                            </div>
                            <div>
                                <label>Upload Sample File</label>
                                <input type='file' id='Sample' required accept={In_bound.type} onChange={(e) => { hanlde_sample_file(e); handle_details('sample', `${randomNumber}`) }} />
                            </div>
                            <div>
                                <label>Data Store to</label>
                                <select onChange={(e) => { handle_from_store('store', e.target.value) }} value={In_bound.store || ''}>
                                    <option>Please Select</option>
                                    <option value={'same'}>Internal</option>
                                    <option value={'new'}>External</option>
                                </select>
                            </div>
                            <div id={In_bound.store === 'new' ? 'block' : 'none'}>
                                <label>Database Type</label>
                                <select onChange={(e) => handle_details('type', e.target.value, 'store_db')} value={In_bound.store_db?.type || ''}>
                                    <option>Please Select</option>
                                    <option value={'mysql'}>Mysql</option>
                                </select>
                            </div>
                            <div id={In_bound.store === 'new' ? 'block' : 'none'}>
                                <label>Enter Database Name</label>
                                <input type='search' id='dbname' value={In_bound.store_db?.db_name} onChange={(e) => handle_details('db_name', e.target.value, 'store_db')} />
                            </div>
                            <div id={In_bound.store === 'new' ? 'block' : 'none'}>
                                <label>Enter Host Name</label>
                                <input type='search' id='host' value={In_bound.store_db?.host} onChange={(e) => handle_details('host', e.target.value, 'store_db')} />
                            </div>
                            <div id={In_bound.store === 'new' ? 'block' : 'none'}>
                                <label>Enter User Name</label>
                                <input type='search' id='User' value={In_bound.store_db?.user} onChange={(e) => handle_details('user', e.target.value, 'store_db')} />
                            </div>
                            <div id={In_bound.store === 'new' ? 'block' : 'none'}>
                                <label>Enter Password</label>
                                <input type='search' id='Password' value={In_bound.store_db?.pass} onChange={(e) => handle_details('pass', e.target.value, 'store_db')} />
                            </div>
                            <div>
                                <label>Schedule Date</label>
                                <select id='S_Date' onChange={(e) => { handle_details('date', e.target.value); setSelectedDays([]); setSelectedDate([]); setFormattedDates([]) }} value={In_bound.date?.type}>
                                    <option value={''}>Please Select</option>
                                    <option value={'Daily'}>Daily</option>
                                    <option value={'Weekly'}>Weekly</option>
                                    <option value={'Monthly'}>Monthly</option>
                                </select>
                            </div>
                            {
                                In_bound.date?.type === 'Weekly' && <div ref={dropdownRef} className='pr'>
                                    <label>Select Day</label>
                                    <input readOnly onClick={toggleDropdown} className='b1' type='search' value={selectedDays.length > 0 ? selectedDays.join(',') : 'Select day(s)'} />
                                    <FaAngleDown className='pa ' onClick={toggleDropdown} style={{ right: '0px', bottom: '0.7vh', width: '8%', height: '1.5vh' }} />
                                    {open && (
                                        <div className='b0111 white' style={{ zIndex: 1 }}>
                                            {weekDays.map((day, i) => (
                                                <label key={i} className='df ac padleft gap'>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedDays.includes(day)}
                                                        onChange={() => toggleDay(day)}
                                                    />
                                                    {day}
                                                </label>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            }
                            {
                                In_bound.date?.type === 'Monthly' && <div ref={ref}>
                                    <label>select Date</label>
                                    <div className="calendar-wrapper" >
                                        <input
                                            type='search'
                                            readOnly
                                            onClick={() => setOpen(!open)}
                                            value={
                                                selectedDate.length > 0
                                                    ? selectedDate.map(d => d.toLocaleDateString()).join(",  ")
                                                    : "Select date(s)"
                                            }
                                        />

                                        {open && (
                                            <div className="calendar-popup">
                                                <DayPicker
                                                    mode="multiple"       // 👈 for multiple selection (use "single" for one date)
                                                    selected={selectedDate}
                                                    onSelect={handledate}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            <div className='pr' ref={TimedownRef}>
                                <label>Schedule Time</label>
                                <input readOnly className='b1' type='search' onClick={toggleDropdowntime} value={selectedTime.length > 0 ? selectedTime.join(',') : 'Select Time'} />
                                <FaAngleDown className='pa ' onClick={toggleDropdowntime} style={{ right: '0px', bottom: '0.7vh', width: '8%', height: '1.5vh' }} />
                                {showtime && (
                                    <div className='b0111 h20 of_a white' style={{ zIndex: 1 }}>
                                        {hoursArray.map((time, i) => (
                                            <label key={i} className='df ac padleft gap'>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedTime.includes(time)}
                                                    onChange={() => toggletime(time)}
                                                />
                                                {time}
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div>
                                <label>Select Country</label>
                                <select onChange={(e) => { handle_details('time', e.target.value); }} value={In_bound.time?.country || ''}>
                                    <option>Select Time Zone</option>
                                    {
                                        countryList().map((country, i) => (
                                            <option value={country} key={i}>{country}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div>
                                <label>Finally File</label>
                                <select id='f_file' onChange={(e) => { handle_from_store('f_file', e.target.value) }} value={In_bound.f_file || ''}>
                                    <option value={''}>Please Select</option>
                                    <option value={'move'}>Move</option>
                                    <option value={'delete'}>Delete</option>
                                </select>
                            </div>
                            <div id={In_bound.f_file === 'move' ? 'block' : 'none'}>
                                <label>Files Moving Path</label>
                                <input type='search' id='m_path' value={In_bound.m_path} onChange={(e) => handle_details('m_path', handle_folder_path(e.target.value))} />
                            </div>
                        </div>
                        <div className='w100 h10 df jc ac white'>
                            <button className='btn green' onClick={submit}>Update</button>
                        </div>
                    </div>
                </div>
            </div>


        </div >
    )
}

export default Edit_In_Bound;